import { CheckCircle, OpenInNew } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { useHistory } from 'react-router-dom';

interface MonitorSuccessModalProps {
  open: boolean;
  onClose: () => void;
  message: React.ReactNode;
  walletId?: number | null;
}

export function MonitorSuccessModal({
  open,
  onClose,
  message,
  walletId,
}: MonitorSuccessModalProps) {
  const history = useHistory();

  const handleGoToWallet = () => {
    if (walletId) {
      history.push(`/monitor/wallet/${walletId}`);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={2}
          py={1}>
          <Typography variant="h6" fontWeight={600}>
            Sucesso
          </Typography>
          <CheckCircle color="success" sx={{ fontSize: 64 }} />
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 1 }}>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Fechar
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleGoToWallet}
          disabled={!walletId}
          endIcon={<OpenInNew fontSize="small" />}>
          Ver carteira
        </Button>
      </DialogActions>
    </Dialog>
  );
}
